import React, { useState, useEffect, useRef, Fragment} from 'react';
import {FormGroup, Input, Label} from 'reactstrap';
import { Table } from 'reactstrap'
import PageTransition from '../PageTransition/PageTransition'
import ReactS3Uploader from 'react-s3-uploader'
import Button from '../Button/Button'
import { Block } from '../../styles/commons'
import ConfirmationModal from '../ConfirmationModal/ConfirmationModal'
import Portal from '../../stacks/portal/PortalAWS'
import {useErrorToast} from '../../hooks/useErrorToast';

const UploadFiles = props => {
  const {setErrorMsg, errorToast} = useErrorToast('');
  const [loadingMessage, setLoadingMessage] = useState('Communicating ...');
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([])
  const [title, setTitle] = useState('')
  const [titleQuery, setTitleQuery] = useState(false)
  const [confirm, setConfirm] = useState(false)
  const uploadRef = useRef(null)


  useEffect(() => {
    async function getList() {
      try {
        setLoading(true)
        setLoadingMessage('Loading ...')
        const api = Portal.getInstance()
        const list = await api.listFileUpload()
        setFileList(list)
        setLoadingMessage('')
        setLoading(false)
        // setText(`${JSON.stringify(list, null, 2)}`)
      }
      catch (err) {
        setErrorMsg(err.message)
        setLoadingMessage('')
        setLoading(false)
      }
    }

    getList();
  }, [setErrorMsg]);

  async function getURL(fileName) {
    try {
      const api = Portal.getInstance()
      const fileTitle = title !== '' ? title : fileName
      const url = await api.retrieveFileUploadURL(fileName, {title: fileTitle})
      return url
    }
    catch (err) {
      setErrorMsg(err.message)
      setLoadingMessage('')
      setLoading(false)
      throw err
    }
  }

  async function getSignedURL(file, callback) {
    try {
      const signedUrl = await getURL(file.name);
      callback({ signedUrl });
    } catch (err) {
      setErrorMsg(err.message)
      setLoadingMessage('')
      setLoading(false)
      console.log(`ERROR getSignedURL ${err.message}`)
    }

  }

  async function getList() {
    try {
      setErrorMsg('')
      setLoadingMessage('Loading ...')
      setLoading(true)
      const api = Portal.getInstance()
      const list = await api.listFileUpload()
      setFileList(list)
      setLoadingMessage('')
      setLoading(false)
      // setText(`${JSON.stringify(list, null, 2)}`)
    }
    catch (err) {
      setErrorMsg(err.message)
      setLoadingMessage('')
      setLoading(false)
      }
  }

  async function removeFile(fileName) {
    try {
      setErrorMsg('')
      setLoadingMessage('Removing ...')
      setLoading(true)
      const api = Portal.getInstance()
      await api.removeFileUploadFile(fileName)
      await getList()
      setLoadingMessage('')
      setLoading(false)
    }
    catch (err) {
      setErrorMsg(err.message)
      setLoadingMessage('')
      setLoading(false)
      }
  }

  function onProgress(value) {
    // console.log(`onProgress ${JSON.stringify(arguments)}`)
    if (value === 0) {
      setErrorMsg('')
      setLoadingMessage('Uploading ...')
      setLoading(true)
    }
  }

  function onError(message, value, xml) {
    setErrorMsg(message)
    setLoadingMessage('')
    setLoading(false)
    // console.log(`onError ${JSON.stringify(arguments)}`)
  }

  function onFinish(value) {
    // console.log(`onFinish ${JSON.stringify(arguments)}`)
    getList()
    setLoadingMessage('')
    setLoading(false)
  }

  function handleFile(e) {
    setTitle('')
    setConfirm(true)
  }

  function confirmCancel() {
    setConfirm(false)
  }

  function confirmAgree() {
    setConfirm(false)
    setTitleQuery(true)
  }

  function processContinue() {
    setTitleQuery(false);
    uploadRef.current.uploadFile();
    uploadRef.current.clear();
  }

  function processContinueNoTitle() {
    setTitleQuery(false);
    setTitle("");
    uploadRef.current.uploadFile();
    uploadRef.current.clear();
  }

  return (
    <Fragment>
      <div>
        <a style={{color: 'red', textDecoration: 'underline'}} href='https://youtu.be/TgefNwpEcLw' target='_blank' rel='noreferrer'>Please watch this short instructional video to ensure your profile is properly set up.</a>
      </div>

      <p>
        <em>
        The DreamEx Connect file upload is provided for the convenience of conveying
        additional documentation to prospective sources of funds. However, this service
        shall not be used to formally solicit for investment and the listing of
        investment documents, such as private placement memorandums, offering circulars,
        prospectuses, etc. are prohibited.”
        </em>
      </p>
      <ReactS3Uploader
        ref={uploadRef}
        getSignedUrl={getSignedURL}
        onProgress={onProgress}
        onError={onError}
        onFinish={onFinish}
        uploadRequestHeaders={{}}
        onChange={handleFile}
        autoUpload={false}
      />
      <PageTransition loading={loading} msg={loadingMessage}/>

      <Block>
        <Table striped size="small">
          <thead>
            <tr>
              <th>Title</th>
              <th>File</th>
              <th>Upload Date and Time</th>
              <th>Size</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {fileList.map((item) => {
              const dateTime = new Date(item.lastModified);
              return (
                <tr key={item.fileName}>
                  <td>{item.title}</td>
                  <td>{item.fileName}</td>
                  <td>{dateTime.toLocaleString()}</td>
                  <td>{item.size}</td>
                  <td>
                    <Button
                      small
                      click={() => {
                        removeFile(item.fileName);
                      }}
                    >
                      Remove
                    </Button>
                  </td>
                  {/* <td><Button small>Download</Button></td> */}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </Block>
      {/* <textarea rows={25} cols={132} value={text} readOnly/> */}
      {titleQuery && (
        <ConfirmationModal
          cancel={() => {
            processContinueNoTitle();
          }}
          confirm={() => {
            processContinue();
          }}
          cancelBtnTitle="NO TITLE"
          confirmationBtnTitle="COMPLETE"
        >
          <FormGroup>
            <Label for='title'>Optional Display title</Label>
            <Input
              id="title"
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
              }}
            />
          </FormGroup>
        </ConfirmationModal>
      )}
      {confirm && (
        <ConfirmationModal
        cancel={confirmCancel}
        confirm={confirmAgree}
        confirmationBtnTitle='AGREE'
        >
        The DreamEx Connect file upload is provided for the convenience of conveying
        additional documentation to prospective sources of funds. However, this service
        shall not be used to formally solicit for investment and the listing of
        investment documents, such as private placement memorandums, offering circulars,
        prospectuses, etc. are prohibited.

        </ConfirmationModal>
      )}
      {errorToast}
    </Fragment>
  );
};

export default UploadFiles;
